<template>
  <div>
      <!--遮罩 开始-->
      <div class="g_pop_mask" @click="close"></div>
      <!-- 分享  开始 -->
      <div class="g_pop_share" @click="close">
          <div class="pop_wrap">
              <div class="pop_con">
              </div>
          </div>
      </div>
      <!-- 分享  结束 -->
  </div>

</template>

<script>
import { setShare } from '../util/share'
import md5 from 'md5'
import env from '@tencent/vft-common/env'
import { getChannel } from '../util/channel'

export default {
  props: ['cover', 'giveUser', 'user'],
  data () {
    return {
    }
  },
  methods: {
    buildGiveMovieShare (taskid) {
      return new Promise((resolve, reject) => {
        // 设置赠片分享文案
        var stamp = 0
        if (!taskid) {
          stamp = Math.round(new Date().getTime() / 1000)
          var encodeStr = ['coverid=', this.cid, '&openid=&timestamp=', stamp, '&uin=', this.user.vipid].join('')
          taskid = md5(encodeStr)
        }
        let giveuin = this.giveuin || this.user.vipid
        var url = ['//', location.host, '/weixin/givemovie.html?cid=', this.cid].join('')
        if (taskid) {
          url += ['&giveuin=', giveuin, '&taskid=', taskid].join('')
        }
        var nick = this.isTakeUser ? this.giveUser.nick : this.userInfo.nick
        var param = {
          title: `${nick}送你《${this.cover.title}》免费观看资格，只有5个名额，先到先得哦~`,
          desc: '小伙伴们快来领取，先到先得，开通腾讯视频VIP每个月都有赠片资格哟',
          imgUrl: this.cover.pic,
          link: url
        }
        setShare(param, (res) => {
          this.$emit('close')
          var channel = 0
          if (res && res.app && res.shareTo) {
            channel = getChannel(res.app, res.shareTo)
          }
          this.report.click({ f_hottag: `h5_givemovie_${channel}` })
          var plat = 0
          if (env.isAndroid) {
            plat = 108
          } else if (env.isIphone) {
            plat = 107
          } else if (env.isIpad) {
            plat = 105
          }
          if (stamp !== 0) {
            return resolve({
              taskid,
              stamp,
              plat,
              channel
            })
          }
          return reject()
        })
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
